<template>
  <div>
    <v-navigation-drawer v-model="drawer" fixed app>
      <v-list dense>
        <v-list-tile
          value="true"
          v-for="(item, i) in items"
          :key="i"
          @click="menuOption(item.action, item.value || false)"
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar :color="temaColor" dark fixed app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <v-btn
          outline
          color="red lighten-1"
          @click.stop="volverAtras"
          v-if="$route.meta.volver"
        >
          <v-icon left>mdi-arrow-left-bold-circle-outline</v-icon>Volver
        </v-btn>
        {{ $route.meta.ruta }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="brown--text text--lighten-1 body-1">{{
        infoBarra ? infoBarra : ""
      }}</span>
      <v-spacer></v-spacer>
      <span>{{ username }}</span>
    </v-toolbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Navigation",
  data() {
    return {
      drawer: false,
      vista: "expedientes"
    };
  },
  computed: {
    ...mapState(["navegationControl"]),
    infoBarra() {
      let result = false;
      if (this.$route.meta && this.$route.meta.navControl) {
        switch (this.$route.meta.navControl) {
          case "expedienteEdit":
          case "inmueblesList":
          case "inmuebleEdit":
            result = `${this.navegationControl.expedienteEdit.customId ||
              ""} - ${this.navegationControl.expedienteEdit.nombreComunidad ||
              ""}`;
            break;

          default:
            break;
        }
      }
      return result;
    },
    temaColor() {
      return this.$store.getters.getTemaColorAdminUI;
    },
    items() {
      return this.$store.getters.getItemsMenuAdmin;
    },
    level() {
      return this.$store.getters.getLevel;
    },
    usuario() {
      return this.$store.getters.getUsuarioAdmin;
    },
    username() {
      return this.usuario ? this.usuario.admin.username : "";
    }
  },
  methods: {
    volverAtras() {
      this.$router.back();
    },
    menuOption(option, value = "profile") {
      switch (option) {
        case "logout":
          this.$auth.signOut();
          this.$router.replace("/");
          break;
        case "vista":
          this.vista = value;
          this.$router.replace(value);
          break;
        default:
          break;
      }
    }
  }
};
</script>
